/**
 * Progress Tracker Component
 * Shows the current step in the add/edit account process
 */

import React from "react";
import { Box, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { RadioButtonUnchecked } from "@mui/icons-material";
import { Icon } from "../../../components/ds";

const ProgressTracker = ({ steps, currentStep }) => {
  const getStepIcon = (index, step) => {
    const stepNumber = index + 1;

    if (step.status === "completed") {
      return <Icon name="success" />;
    } else if (step.status === "error") {
      return <Icon name="error" />;
    } else if (stepNumber === currentStep) {
      return (
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: "primary.main",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            fontWeight: "bold",
          }}
        >
          {stepNumber}
        </Box>
      );
    } else {
      return <RadioButtonUnchecked sx={{ color: "action.disabled" }} />;
    }
  };

  return (
    <Box sx={{ width: "100%", py: 0.25 }}>
      <Stepper
        activeStep={currentStep - 1}
        alternativeLabel
        sx={{
          "& .MuiStepConnector-root": {
            top: 12,
          },
          "& .MuiStep-root": {
            padding: "0 2px",
          },
        }}
      >
        {steps.map((step, index) => (
          <Step key={step.title}>
            <StepLabel
              StepIconComponent={() => getStepIcon(index, step)}
              sx={{
                "& .MuiStepLabel-labelContainer": {
                  marginTop: "2px",
                  "& .MuiStepLabel-label": {
                    fontSize: "0.875rem",
                    fontWeight: index + 1 === currentStep ? "bold" : "normal",
                    lineHeight: 1.1,
                    color:
                      step.status === "error"
                        ? "error.main"
                        : step.status === "completed"
                        ? "success.main"
                        : index + 1 === currentStep
                        ? "primary.main"
                        : "text.secondary",
                  },
                },
              }}
            >
              {step.title}
            </StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Current step description */}
      <Box sx={{ textAlign: "center", mt: 0.5, minHeight: 5 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontSize: "0.8rem",
            fontStyle: "italic",
            lineHeight: 1.1,
          }}
        >
          {steps[currentStep - 1]?.description}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProgressTracker;
